<template>
    <div>
      <!-- 头部 -->
      <top></top>
      <div class="main">
        <navMenu :active="active"></navMenu>
        <div class="content">
          <div class="go-back"  @click="goBack">返回</div>
          <div class="header_box">
              <div style="width: 100%;">
                <div class="main-title">发票</div>
                  <!-- <div class="main-sub">
                    请在此页面内为您的单位提供详细的展示资料，以便于专业买家在becia展商平台上查询与筛选时更好的展现。
                  </div> -->
              </div>
            <div class="create-btn" @click="addposition">
                添加发票
            </div>
          </div>
          <!-- 列表 -->
          <div class="invitation-table">
            <el-table
             v-if="tableData.length>0"
              class="my-table"
              :data="tableData"
              stripe
              v-loading="loading"
              style="width: 100%; min-height: 600px"
              :header-cell-style="{
                textAlign: 'center',
                color: '#3A3A3C',
                fontWeight: 'normal',
                fontSize: '14px',
              }"
              :cell-style="{ textAlign: 'center',fontSize: '14px', }"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column
                prop="type"
                label="发票类型"
                width="100"
                sortable
              ></el-table-column>
              <!-- <el-table-column label="照片">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img"
                    style="width: 69px; height: 69px; display: block;margin: 0 auto;"
                  ></el-image>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="title"
                  width="400"
                label="发票抬头"
              ></el-table-column>
              <el-table-column
                prop="email"
                  width="300"
                label="邮箱"
              ></el-table-column>
              <!-- <el-table-column
                label="产品分类"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.product_type[0].tname ? scope.row.product_type[0].tname : '-'}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.status ? '上架' : '下架'}}</div>
                </template>
              </el-table-column> -->
          
              <el-table-column
                prop="phone"
                label="手机"
                width="200"
              ></el-table-column>
              <!-- <el-table-column
                prop="name"
                label="快递单号"
               
              ></el-table-column>
              <el-table-column
                prop="position"
                label="邮寄时间"
               
              ></el-table-column> -->
              <el-table-column
                prop="update_time"
                label="最后修改时间"
                sortable
                width="200"
              ></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <span class="check-btn" @click="edit(scope.row,1)"
                    >编辑</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <nodata v-else></nodata>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pagesize"
              layout="total, prev, pager, next, jumper"
              :total="totals"
            >
            </el-pagination>
          </div>
        </div>
     
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        :before-close="handleClose">
         <div>
            <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-position="right"
            label-width="100px"
            >
           
            <el-form-item label="票种："  prop="category">
                <el-radio-group v-model="ruleForm.category" :disabled="title=='编辑发票'?true:false">
                    <el-radio label="专票">专票</el-radio>
                    <el-radio label="普票">普票</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发票类型："   prop="type">
                <el-radio-group v-model="ruleForm.type">
                    <el-radio label="预付款发票">预付款发票</el-radio>
                    <el-radio label="尾款发票">尾款发票</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发票抬头："  prop="title">
                <el-input  placeholder="请填写发票抬头" v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="发票内容："  prop="content">
                <el-radio-group v-model="ruleForm.content">
                    <el-radio label="展览服务">展览服务</el-radio>
                    <el-radio label="会议服务">会议服务</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="统一社会信用代码："  prop="credit_code">
                <el-input  placeholder="请填写统一社会信用代码" v-model="ruleForm.credit_code"></el-input>
            </el-form-item>
            <el-form-item label="税务备案电话：" v-if="ruleForm.category=='专票'" prop="tax_phone">
                <el-input  placeholder="请填写税务备案电话" v-model="ruleForm.tax_phone"></el-input>
            </el-form-item>
            <el-form-item label="税务备案地址：" v-if="ruleForm.category=='专票'"  prop="tax_address">
                <el-input  placeholder="请填写税务备案地址" v-model="ruleForm.tax_address"></el-input>
            </el-form-item>
            <el-form-item label="税务备案开户行：" v-if="ruleForm.category=='专票'" prop="tax_bank">
                <el-input  placeholder="请填写税务备案开户行" v-model="ruleForm.tax_bank"></el-input>
            </el-form-item>
            <el-form-item label="税务备案开户行账号：" v-if="ruleForm.category=='专票'"  prop="tax_bank_account">
                <el-input  placeholder="请填写税务备案开户行账号" v-model="ruleForm.tax_bank_account"></el-input>
            </el-form-item>
            <!--<el-form-item label="收件人：" prop="recipient_user">-->
                <!--<el-input  placeholder="请填写收件人" v-model="ruleForm.recipient_user" prop="recipient_user"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="手机：" prop="phone" class="ts" >
                <el-select v-model="phonesel" style="margin-right: 15px;">
                  <el-option
                      v-for="item in codedata"
                      :key="item.id"
                      :label="item.country +' '+ item.phone_code"
                      :value="item.phone_code"
                    >
                    </el-option>
                </el-select>
                <el-input v-model="ruleForm.phone" clearable placeholder="手机号码" />
              </el-form-item>
              <el-form-item label="座机：" prop="line_phone" class="ts">
                <el-select v-model="line_phonesel" style="margin-right: 15px;">
                  <el-option
                      v-for="item in codedata"
                      :key="item.id"
                      :label="item.country +' '+ item.phone_code"
                      :value="item.phone_code"
                    >
                    </el-option>
                </el-select>
                <el-input v-model="ruleForm.line_phone" clearable placeholder="座机号码" />
              </el-form-item>
                <el-form-item
                        prop="email"
                        label="邮箱"

                >
                    <el-input v-model="ruleForm.email" placeholder="请填写邮箱"></el-input>
                </el-form-item>

          <!--<el-form-item label="收件地址：" prop="shipping_address">-->
            <!--<el-input   placeholder="请填写收件地址" v-model="ruleForm.shipping_address"></el-input>-->
          <!--</el-form-item>-->
          </el-form>
         </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit('ruleForm')">确 定</el-button>
        </span>
        </el-dialog>
    </div>
    
  </template>
  
  <script>
  import { invoiceList, invoiceDetails,addInvoice,editInvoice } from "@/api/api";
  import top from "../components/top.vue"; //头部
  import navMenu from "../components/navMenu.vue"; //左侧步骤条
  import nodata from "../components/nodata.vue"; //头部
  
  export default {
    components: { top, navMenu,nodata },
    name: "nameTag",
    data() {
      return {
        ruleForm:{
            invoice_long_id:"",
            category:"",
            type:"",
            title:"",
            content:"",
            credit_code:"",
            tax_phone:"",
            tax_address:"",
            tax_bank:"",
            tax_bank_account:"",
            // recipient_user:"",
            phone:"",
            line_phone:"",
            email:""
            // shipping_address:""
        },
        line_phonesel:'',
        phonesel:"",
        status:'0',
        loading: false,
        active: 2,
        position: "",
        totals: 0,
        tableData: [],
        currentPage: 1,
        page: 1,
        pagesize: 10,
        typeList: [],
        dialogVisible:false,
        title:'',
        codedata:[],
        rules: {
          category: [{ required: true, message: "请选择", trigger: "change" },],
          type: [{required: true,message: "请选择",trigger: "blur",},],
          content: [{required: true,message: "请选择",trigger: "blur",},],
          title: [{ required: true, message: "请填写", trigger: "blur" }],
          credit_code: [{ required: true, message: "请填写", trigger: "blur" }],
          tax_phone: [{ required: true, message: "请填写", trigger: "blur" }],
          tax_address: [{ required: true, message: "请填写", trigger: "blur" }],
          tax_bank: [{ required: true, message: "请填写", trigger: "blur" }],
          tax_bank_account: [{ required: true, message: "请填写", trigger: "blur" }],
          // recipient_user: [{ required: true, message: "请填写", trigger: "blur" }],
          phone: [{ required: true, message: "请填写", trigger: "blur" },{pattern: /^1[3-9]\d{9}$/,message: "手机号码格式不正确",trigger: "blur",},],
          // shipping_address: [{ required: true, message: "请填写", trigger: "blur" }]
           email: [
                    { required: true, message: '请填写邮箱地址', trigger: 'blur' },
                { type: 'email', message: '请填写正确的邮箱地址', trigger: ['blur', 'change'] }
            ]
      },
        mark:''
      };
    },
    mounted() {
        this.codedata = JSON.parse(localStorage.getItem("codedata"));
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "/aptitude";
      });
      this.active = index;
      this.mark=this.$route.query.mark;
      this.page = 1;
      // 获取列表
      this.getList(this.page, this.position);
    },
    created() {},
    methods: {
        dialogSubmit(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
            let data=this.ruleForm;
            data.mark=this.mark;
            if(this.phonesel){
                data.phone=this.phonesel+'-'+data.phone;
            }
            if(this.line_phonesel){
                data.line_phone=this.line_phonesel+'-'+data.line_phone;
            }
            if(data.invoice_long_id){//编辑
                this.editInvoice(data)    
            }else{// 新增
                this.addInvoice(data)    
            }
          }
        })

        },
          //新增
          addInvoice(data){
            addInvoice(data).then((res) => {
            console.log(res, "===新增数据");
            if (res.code == 1) {
                this.$message.success(res.msg);
                this.dialogVisible=false;
                this.getList(this.page, this.position);
            } else {
              this.$message.warning(res.message);
            }
          }).catch((err) => {
            console.log(err)
          });
      },
       //编辑
       editInvoice(data){
        editInvoice(data).then((res) => {
            console.log(res, "===修改数据");
            if (res.code == 1) {
                this.$message.success(res.msg);
              this.dialogVisible=false;
              this.getList(this.page, this.position);
            } else {
              this.$message.warning(res.msg);
            }
          })
          .catch((err) => {
            console.log(err)
          });
      },
    handleClose(){
       this.dialogVisible=false;
    },
     // 添加职位
     addposition(){ 
      
       this.ruleForm.invoice_long_id=""
        this.ruleForm.category=""
        this.ruleForm.type=""
        this.ruleForm.title=""
        this.ruleForm.content=""
        this.ruleForm.credit_code=""
        this.ruleForm.tax_phone=""
        this.ruleForm.tax_address=""
        this.ruleForm.tax_bank=""
        this.ruleForm.tax_bank_account=""
        this.ruleForm.recipient_user=""
        this.ruleForm.phone=""
        this.phonesel=""
        this.ruleForm.line_phone=""
        this.line_phonesel=""
        this.ruleForm. shipping_address=""
        this.dialogVisible=true;
        this.title="添加发票"
     },
      //搜索
      search(){
        this.page = 1;
        this.getList(this.page, this.position);
      },
      reset(){
        this.page = 1;
        this.position="";
        this.getList(this.page, this.position);
      },
      //获取列表
      getList(page, position) {
        let data = this.$qs.stringify({
          page_size: this.pagesize,
          page_no: page,
          position,
        });
        this.loading = true;
        invoiceList(data).then((res) => {
            if (res.code == 1) {
              this.loading = false;
              let { data } = res;
              let arr = data.lists;
              this.tableData = arr;
              this.totals = data.count;
            }else{
              this.$message.warning(res)
            }
          })
          .catch((err) => {
            if(err.response.code != 401){
              this.$message.warning(err.response.data)
            }
          });
      },
    
      // 返回
      goBack() {
        this.$router.back();
      },
      // 编辑
      edit(row){
         this.title="编辑发票"
         this.dialogVisible=true;
         this.ruleForm.invoice_long_id=row.invoice_long_id;
         this.getdetail(row.invoice_long_id)
         
      },
      // 获取详情
      getdetail(invoice_long_id){
        invoiceDetails({invoice_long_id}).then(res=>{
            if(res.code==1){
                 this.phonesel = res.data.phone.split('-').join(',').split(',')[0];
                 this.line_phonesel = res.data.line_phone.split('-').join(',').split(',')[0];
                 this.ruleForm=res.data;
                 this.ruleForm.phone = res.data.phone.split('-').join(',').split(',')[1];
                 this.ruleForm.line_phone = res.data.line_phone.split('-').join(',').split(',')[1];
            }

        }).catch(err=>{
            console.log(err)
        })
      },
      // 分页相关
      handleCurrentChange(val) {
        this.page = val;
        this.getList(this.page, this.position)
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  /deep/ .el-dialog__body{
    height: 500px;
    overflow: auto;
  }
  /deep/ .ts .el-form-item__content{
    display: flex;
    align-items: center;
  }
  .pagination_box{
    text-align: right;
    margin-top: 50px;
  }
  .goods_name{
    line-height: 20px;
    font-size:16px;
    font-weight: 600;
    color: #000;
  }
  .tname{
    font-size:14px;
    font-weight: 400;
    color: #000;
    margin-top: 15px;
  }
  .inputtime{
    font-size:12px;
    font-weight: 400;
    color: #969696;
    margin-top: 10px;
    line-height: 18px;
  }
  .p_footer{
    display: flex;
   
    .p_item_footer{
      width: 50%;
      height: 64px;
      line-height: 64px;
      text-align: center;
     
    }
    .p_item_footer:nth-child(1){
      border-right: 2px solid #eee;
    }
    
  }
  .header_box{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px
  }
   .create-btn {
      width: 148px;
      height: 42px;
      color: #fff;
      font-size: 19px;
      font-weight: 500;
      cursor: pointer;
      line-height: 42px;
      text-align: center;
      background: #1677ff;
      border-radius: 4px;
      &:hover{
        text-decoration: underline;
      }
    }
  .content-type {
    padding-bottom: 35px;
    .main-title {
      width: 100%;
      margin-top: 40px;
    }
  }
  .p_list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // background: #fff;
    // border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
  .p_item{
       width: -webkit-calc((100% - 20px * 4)/ 4);
        width: calc((100% - 20px * 4) / 4);
        margin: 0 20px 20px 0;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  .p_item_top{
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select_box{
      width: 80px;
    }
  }
  .p_item_scoend{
    margin-top: 10px;
    padding: 0 15px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #eee;
    img{
      width: 100px;
      height: 100px;
      border-radius: 10px;
      margin-right: 20px;
    }
  }
  .search-wrap {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    margin-top: 50px;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
   
    margin-bottom: 20px;
    .search-input {
      align-items: center;
    }
    .search-input .search-btn {
      width: 130px;
      height: 42px;
     
      cursor: pointer;
      font-size: 19px;
      margin-right: 11px;
      line-height: 42px;
      text-align: center;
      // background: #2c2c2e;
      border-radius: 4px;
      &:hover{
        text-decoration: underline;
      }
    }
    .search{
      background: #008DFF;
      color: #fff;
    }
    .reset{
      color: #2690E6;
      border: 1px solid #008DFF;
      margin-left: 11px;
    }
   
  }
  .invitation-table{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 30px !important;
    padding-top: 0 !important;
    border-top: 0 none !important;
  }
  </style>
  <style lang="scss">
  .search-wrap {
    .search-input {
      .el-input {
        font-size: 14px;
        width: 40%;
      }
      .el-input__inner {
        height: 42px;
        line-height: 42px;
        border-radius: 4px;
      }
    }
  }
  .invitation-table .el-pagination {
    margin-top: 30px;
    text-align: center;
    .el-pager li,
    .el-pagination__total {
      font-size: 14px;
    }
    .el-pagination__jump {
      font-size: 14px;
    }
  }
  .my-table {
    color: #888;
    font-size: 18px;
    // margin-top: 30px;
  }
  .my-table tbody td,
  .my-table tbody th {
    height: 70px;
    padding: 5px 0;
    box-sizing: border-box;
  }
  .my-table tbody th,
  .my-table tbody tr {
    background: #f2f6fb;
  }
  .my-table tbody tr.is-new {
    color: #0e0e0e;
  }
  .check-btn {
    color: #1677ff;
    cursor: pointer;
    margin-left: 20px;
  }
  .check-btn:hover{
    text-decoration: underline;
  }
  .check-del {
    color: #ff4d4f;
   
  }
  .my-table tbody tr td .check-btn {
    color: #1677ff;
    cursor: pointer;
  }
  .my-table tbody tr td .check-btn:hover{
    text-decoration: underline;
  }
  .my-table tbody tr td .check-btn.check-del {
    color: #ff4d4f;
    // margin-left: 50px;
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fff;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 0 none;
  }
  /* 表格最外层边框-底部边框 */
  .el-table--border::after,
  .el-table--group::after {
    width: 0;
  }
  .my-table::before {
    width: 0;
  }
  .my-table tbody tr td:first-child {
    border-radius: 10px 0 0 10px;
  }
  .my-table tbody tr td:last-child {
    border-radius: 0 10px 10px 0;
  }
  @media only screen and (max-width: 1366px) {
    .p_list{
      width: 100% !important;
    }
    .p_item{
       width: -webkit-calc((100% - 20px * 3)/ 3) !important;
        width: calc((100% - 20px * 3) / 3)!important;
        margin: 0 20px 20px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 1280px) {
    .p_list{
    width: 100% !important;
   
  }
    .p_item{
    
       width: -webkit-calc((100% - 15px * 2)/ 2) !important;
        width: calc((100% - 15px * 2) / 2)!important;
        margin: 0 15px 15px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 1200px) {
    .p_list{
    width: 100% !important;
   
  }
    .p_item{
  
       width: -webkit-calc((100% - 15px * 2)/ 2) !important;
        width: calc((100% - 15px * 2) / 2)!important;
      //   margin: 0 15px 15px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 767px) {
    /deep/ .el-dialog{
      width: 100% !important;
    }
    .invitation-table{
      width: 92%;
    }
    .el-pagination {
      padding: 2px 23px !important;
    }
    .p_item_footer{
      height: 54px!important;
      line-height: 54px!important;
      font-size:14px!important;
    }
    .tname{
      margin-top: 10px !important;
    }
    .inputtime{
      margin-top: 10px !important;
    }
    .p_item_scoend img{
      width: 80px !important;
      height: 81px !important;
      margin-right: 15px !important;
  }
    .create-btn{
      width: 120px !important;
      height: 40px !important;
      font-size: 15px !important;
    }
    .search-wrap .search-input .search-btn{
      width: 130px!important;
      height: 40px!important;
      font-size: 15px !important;
    }
    .content{
      padding: 30px 0 130px 0;
    }
    .p_item{
      width: 100% !important;
      margin: 0 auto 20px !important;
    }
  .p_list{
    width: 100% !important;
    margin-left: 0 !important;
    display: inline-block !important;
   
  }
  .search-wrap{
    width: 100% !important;
    margin:0 auto !important;
  }
  .search-input{
  flex-wrap: wrap;
  }
  .el-input__inner{
    // width: 90% !important;
    margin: 20px 0;
  }
  .main-sub{
    width: 100%;
    padding-bottom: 8px !important;
  }
  .header_box{
   
    padding-bottom: 50px !important;
  }
  .create-btn{
    margin-bottom: 20px !important;
    position: absolute;
    right: 24px;
    bottom: 0;
  }
  .search-wrap .search-input .el-input{
    width: 100% !important;
  }
  
  }
  </style>
  <style>
   .el-dialog{
      width: 40%;
    }
  @media only screen and (max-width: 767px) {
    .el-pagination {
      padding: 2px 23px !important;
    }
    .el-dialog{
      width: 100%;
    }
  }
  </style>